type Props = {
  incomeMultiplier: number;
  costMultiplier: number;
  onChangeIncome: (v: number) => void;
  onChangeCost: (v: number) => void;
  impactValue?: number;
  baseIncome: number;
  baseCost: number;
  periodMode: 'annual' | 'monthly';
};

export default function SensitivitySliders({
  incomeMultiplier,
  costMultiplier,
  onChangeIncome,
  onChangeCost,
  impactValue,
  baseIncome,
  baseCost,
  periodMode,
}: Props) {
  const pct = (v: number) => Math.round((v - 1) * 100);
  const fmt = (n: number) =>
    Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(n);

  const scale = (val: number) => periodMode === 'monthly' ? val / 12 : val;

  const totalIncome = baseIncome * incomeMultiplier;
  const totalCost = baseCost * costMultiplier;
  const diffIncome = baseIncome * (incomeMultiplier - 1);
  const diffCost = baseCost * (costMultiplier - 1);

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 140px", gap: 16, alignItems: "center" }}>
        <div>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: 600 }}>
            Ingresos
          </label>
          <input
            type="range"
            min="0.6"
            max="1.5"
            step="0.01"
            value={incomeMultiplier}
            onChange={(e) => onChangeIncome(+e.target.value)}
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 700, fontSize: "16px", color: "var(--text)" }}>
            {fmt(scale(totalIncome))}
          </div>
          <div style={{ fontSize: "12px", color: "var(--muted)", marginTop: "2px" }}>
            {pct(incomeMultiplier) >= 0 ? "+" : ""}
            {pct(incomeMultiplier)}%
          </div>
          <div
            style={{
              fontSize: "11px",
              marginTop: "4px",
              color: diffIncome >= 0 ? "#059669" : "#dc2626",
            }}
          >
            {diffIncome >= 0 ? "+" : ""}
            {fmt(scale(diffIncome))}
          </div>
        </div>

        <div>
          <label style={{ display: "block", marginBottom: "8px", fontWeight: 600 }}>
            Costes
          </label>
          <input
            type="range"
            min="0.6"
            max="1.5"
            step="0.01"
            value={costMultiplier}
            onChange={(e) => onChangeCost(+e.target.value)}
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontWeight: 700, fontSize: "16px", color: "var(--text)" }}>
            {fmt(scale(totalCost))}
          </div>
          <div style={{ fontSize: "12px", color: "var(--muted)", marginTop: "2px" }}>
            {pct(costMultiplier) >= 0 ? "+" : ""}
            {pct(costMultiplier)}%
          </div>
          <div
            style={{
              fontSize: "11px",
              marginTop: "4px",
              color: diffCost >= 0 ? "#dc2626" : "#059669",
            }}
          >
            {diffCost >= 0 ? "+" : ""}
            {fmt(scale(diffCost))}
          </div>
        </div>
      </div>
      {impactValue !== undefined && impactValue !== 0 && (
        <div
          style={{
            marginTop: 16,
            padding: "12px 16px",
            backgroundColor: "#f8f9fb",
            borderRadius: "8px",
            borderLeft: "3px solid var(--brand)",
          }}
        >
          <div style={{ fontSize: "14px", color: "var(--text)", marginBottom: "4px" }}>
            <strong>Impacto en tu neto {periodMode === 'monthly' ? 'mensual' : 'anual'}:</strong>{" "}
            <span
              style={{
                fontWeight: 700,
                fontSize: "16px",
                color: impactValue > 0 ? "#10b981" : "#ef4444",
              }}
            >
              {impactValue > 0 ? "+" : ""}{fmt(impactValue)}
            </span>
          </div>
          <div style={{ fontSize: "12px", color: "var(--muted)" }}>
            Diferencia en tu salario neto final después de IRPF y gastos
          </div>
        </div>
      )}
    </div>
  );
}
